import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Amplify } from 'aws-amplify';
import { environment } from './environments/environment';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.amplifyConfiguration.userPoolId,
      userPoolClientId: environment.amplifyConfiguration.userPoolClientId,
      loginWith: {
        oauth: {
          domain: environment.amplifyConfiguration.oauth.domain,
          scopes: environment.amplifyConfiguration.oauth.scopes,
          redirectSignIn: environment.amplifyConfiguration.oauth.redirectSignIn,
          redirectSignOut: environment.amplifyConfiguration.oauth.redirectSignOut,
          responseType: environment.amplifyConfiguration.oauth.responseType as 'code' | 'token',
        },
      },
    },
  },
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
